import { render, staticRenderFns } from "./global_check_group_or_user.vue?vue&type=template&id=5bbb6e48&scoped=true&"
import script from "./global_check_group_or_user.vue?vue&type=script&lang=js&"
export * from "./global_check_group_or_user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbb6e48",
  null
  
)

export default component.exports